import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';

import {clientsUnitsService} from '@store/clients/units/clients-units.service';
import {ClientsUnitsState} from '@store/clients/units/clients-units.store';

type SearchClientsUnitsParams = Partial<ClientsUnitsState>

export const searchClientsUnitsEffect = createEffectFn((params$: Observable<SearchClientsUnitsParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => clientsUnitsService.getClientsUnits().pipe(catchError(() => EMPTY))),
  );
});
